<template>
  <el-form
    label-width="100px"
    class="demo-ruleForm"
  >
    <!-- 返回上一页 -->
	<el-page-header @back="goBack"  content="权限分配"></el-page-header>
    <el-card class="card" shadow="never">
      <el-form-item label="目标用户" prop="type">
        <el-radio-group v-model="dataList.type" @change="typeUpdte">
          <el-radio label="1">全部用户</el-radio>
          <el-radio label="0">指定用户</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 展示全部用户 -->
      <div class="fixeddiv" v-show="dataList.type == 0">
        <keep-alive>
          <div>
            <my-search
              :inputArr="inputArr"
              :order="1"
              :searchParams="searchParams"
              @searchEvent="searchEvent"
            />
            <!-- 表格展示查询的数据  -->
            <myTable
              ref="user"
              isSelection
              :loading="loading"
              :tableData="allUser"
              :tableHeader="tableHeader"
              @handleSelectionChange="handleSelectionChange"
            />
            <!-- 分页器 -->
            <my-pagination :childMsg="pageParams" @callFather="callFather" />
          </div>
        </keep-alive>
      </div>

      <!-- 确定按钮 -->
      <div class="button">
        <el-button type="primary" @click="submitForm()"
          >确定</el-button
        >
      </div>
    </el-card>
  </el-form>
</template>

<script>
import { userListAuth ,articleSortPermissions} from "@/network/system/user"
import mixins from "@/mixins/common";
import { canSearch } from "../../utils/utils";
export default {
  mixins: [mixins],
  data() {
    return {
      inputArr: [
        {
          name: "userZh",
          defaultText: "请输入用户名称",
        },
      ],
      searchParams: { userZh: "" },
      tableHeader: Object.freeze([
        {
          name: "用户",
          prop: "userZh",
        },
      ]),
      // 确认携带字段
      dataList: {
        userIds  : [],//用户id数组
        navId : "",//分类id
        type: "1", //1代表所有用户
      },
      allUser: [],
      checkedUser: [],
    };
  },
  created() {
  	this.dataList.navId = this.$route.query.id;
  },
  methods: {
    async getInitData(isSearch) {
      let params = {
        current: isSearch ? 1 : this.pageParams.currentPage,
        size: this.pageParams.pageSize,
        data: {
          userZh: this.searchParams.userZh, //获取用户列表数据
        },
      };
      let { data } = await userListAuth(params);
      if (data.code == 200) {
        this.allUser = data.data.records;
        this.pageParams.total = data.data.total;
        this.loading = false;
        if (isSearch) this.pageParams.currentPage = 1;
      }
    },
    // 确认按钮
    async submitForm() {
		// 如果是指定客户需要收集userIds字段
		if (this.dataList.type == "0") {
		  // 判断选中用户是否为空
		  if (!this.checkedUser.length) {
		    this.$message({
		      message: "最少选择一个用户",
		      type: "warning",
		    });
		    return;
		  }
		  this.checkedUser.forEach((item) => {
		    this.dataList.userIds.push(item.id);
		  });
		};
		
		let { data } = await articleSortPermissions(this.dataList);
		if (data.code == "200") {
		  this.$message({
		    message: "分配成功",
		    type: "success",
		  });
		  this.dataList.userIds = [];
		  this.dataList.navId = "";
		  // 清空选中项和文本框的内容
		  this.$bus.$emit("clearSelection");
		}
    },
    typeUpdte(value) {
      this.dataList.userIds = []; //清空用户id数组
    },

    //接口用的时候传给组件
   searchEvent() {
      if (canSearch(this, this.searchParams)) return;
      this.getInitData(true);
    },
    // 收集选中的用户
    handleSelectionChange(val) {
      this.checkedUser = val;
    },
	goBack(){//返回上个页面
		this.$router.go(-1)
	},
  },
};
</script>


<style scoped>
.title {
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  color: #333;
  border-bottom: 1px solid #f4f2f0;
  margin-bottom: 20px;
}
.button {
  margin-top: 20px;
  margin-left: 25px;
}
.card {
  margin-top: 20px;
  margin-bottom: 20px;
}
.fixeddiv {
  margin-left: 20px;
}
.el-row {
  margin-bottom: 10px;
}
</style>
